export const OBJECT_FIT_CONTAIN = false;
